module.exports = __webpack_public_path__ + "img/payrollReport.154c64c9.svg";